import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import router from './router';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './config/queryClientFactory';
import CookieBot from 'react-cookiebot';
import { SENTRY_DSN, SENTRY_ENVIRONMENT } from './constants/config.ts';

const domainGroupId = '67696235-e0b5-419e-9788-b37934d81c9e';

if (SENTRY_DSN && import.meta.env.PROD) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        networkDetailAllowUrls: [
          window.location.origin,
          /^https:\/\/shopping\.yettel\.rs/
        ],
        networkRequestHeaders: ['Cache-Control', 'X-Version'],
        networkResponseHeaders: ['Referrer-Policy']
      }),
      Sentry.httpClientIntegration()
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [/^https:\/\/shopping\.yettel\.rs/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
    {import.meta.env.PROD && <CookieBot domainGroupId={domainGroupId} />}
  </React.StrictMode>
);
